export default __webpack_public_path__ + "static/media/DreamCast_Logo_Icon.c2a7f388.svg";